export const translatableFields: Record<string, string[]> = {
  'dictionaries:dictionary_entry': ['label'],
}

export default translatableFields
